// Get the banner element
const banner = document.querySelector('.promotion-js');

// Get the banner divs
const bannerDivs = banner.querySelectorAll('div');

// Get the initial active div
const initialActiveDiv = banner.querySelector('.active');

// Set the current banner div index
let currentBannerIndex;

if (initialActiveDiv) {
    // If an active div is already present in the HTML, start the rotation from the next div
    currentBannerIndex = Array.from(bannerDivs).indexOf(initialActiveDiv) + 1;
} else {
    // If no active div is present in the HTML, start the rotation from the first div
    currentBannerIndex = 0;
}

// Function to change the banner div
function changeBanner() {
    // Remove the active class from all divs
    bannerDivs.forEach(div => div.classList.remove('active'));

    // Add the active class to the next div
    bannerDivs[currentBannerIndex].classList.add('active');
    bannerDivs[currentBannerIndex].classList.add('animation');

    // Update the current banner index
    currentBannerIndex = (currentBannerIndex + 1) % bannerDivs.length;
}

// Start the banner rotation
setInterval(changeBanner, 8000);



class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    // this.elements.button.addEventListener('blur', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    if (this.elements.button.getAttribute('aria-expanded') === 'true'){
      this.hidePanel();
      console.log("HELLO")
    }else {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}
customElements.define('localization-form', LocalizationForm);

function hide (elements) {
  elements = elements.length ? elements : [elements];
  for (var index = 0; index < elements.length; index++) {
    elements[index].style.display = 'none';
  }
}


window.addEventListener('load', function(event) {
    if (document.querySelector('.revy-bundle-message-raw')){
      // hide(document.querySelectorAll('.discount-hide'));
      const span1 = document.createElement("span");
      const span2 = document.createElement("span");
      span1.innerHTML = "Discount";
      span2.innerHTML = "Total";
      document.getElementById("subtotal-js").appendChild(span1);
      span1.after(span2);
      console.log("DONE");
    }
});

